<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES96UC3']['10'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="detail-block">

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES96UC3']['20'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES96UC3']['30'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES96UC3']['40'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="dtechq" name="dtechq">{{ setDateOutput(detail.tab1.dtechq) }}</div>
                  </div>
                </div>        

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES96UC3']['50'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddesc_codidchq" name="coddesc_codidchq">{{ detail.tab1.codidchq }} - {{ detail.tab1.desc_codidchq }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES96UC3']['60'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddesc_codchgsh" name="coddesc_codchgsh">{{ detail.tab1.codchgsh }} - {{ detail.tab1.desc_codchgsh }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES96UC3']['70'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100 txtarea-width response-full-width" id="reason" name="reason">{{ detail.tab1.reason }}</div>
                  </div>
                </div>  
              </div>

              <div class="clearfix">

                <div class="detail-block-float detail-block-left">

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES96UC3']['80'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_codempid2" name="coddesc_codempid2">{{ detail.tab1.codempid2 }} - {{ detail.tab1.desc_codempid2 }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES96UC3']['100'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_shfreqo" name="coddesc_shfreqo">{{ detail.tab1.shfreqo }} - {{ detail.tab1.desc_shfreqo }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES96UC3']['120'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_shfreqn" name="coddesc_shfreqn">{{ detail.tab1.shfreqn }} - {{ detail.tab1.desc_shfreqn }}</div>
                    </div>
                  </div>
                </div>

                <div class="detail-block-float detail-block-right">

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES96UC3']['90'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_codidchq2" name="coddesc_codidchq2">{{ detail.tab1.codidchq2 }} - {{ detail.tab1.desc_codidchq2 }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES96UC3']['110'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_shfreqo2" name="coddesc_shfreqo2">{{ detail.tab1.shfreqo2 }} - {{ detail.tab1.desc_shfreqo2 }}</div>
                    </div>
                  </div>

                  <div class="clearfix detail-row">
                    <div class="detail-left label-left">{{ labels['HRES96UC3']['130'] }}</div>
                    <div class="detail-right ">
                        <div class="detail-text width-100" id="coddesc_shfreqn2" name="coddesc_shfreqn2">{{ detail.tab1.shfreqn2 }} - {{ detail.tab1.desc_shfreqn2 }}</div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres96u-detail',
  props: [ 'labels', 'detail', 'toggle', 'data', 'labelsButton' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?2d5e7532